export default [
  { code: 'Success', label: 'Aprobado', value: 'aprobado' },
  { code: 'Danger', label: 'Desaprobado', value: 'desaprobado' },
  { code: 'Warning', label: 'Advertencia', value: 'advertencia' },
]
